import React, { useEffect, useState, useRef } from "react";
import ProductoList from "../components/ProductoList";
import { useProductStore } from "../hooks";
import {
  handleDecrementProduct,
  handleDeleteRow,
  handleIncrementProduct,
} from "../helpers/useArticulos";
import estadoDespacho from "../api/estadoDespacho";
import articulos from "../api/articulos";
import catalogo from "../api/catalogo";
import MenuSection from "../components/MenuSection";
import { ArticuloKiosk } from "../components/kiosk-components/articulos/articulo-kiosk";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Typography,
  LinearProgress,
} from "@mui/material";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { useTheme } from "@emotion/react";
import { useNavigate, useLocation } from "react-router-dom";
import { Detalles } from "../components/kiosk-components/detalles-kiosk/detalles";
import { TotalBar } from "../components/kiosk-components/detalles-kiosk/total-bar";
import { Promociones } from "../components/kiosk-components/detalles-kiosk/promociones";
import { MetodosPagosKiosk } from "../components/kiosk-components/metodos-pagos-kiosk/metodos-pagos-kiosk";
import { generarFacturaInfo } from "../helpers/generarFacturaInfo";
import scanning from "../images/scanning.png";
import articulosTotem from "../api/articulosTotem";
import DialogImg from "../components/DialogImg";
import fullBienvenido from "../images/full_bienvenido.jpg";
import Slide from "@mui/material/Slide";
import { v4 as uuidv4 } from "uuid";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export const DetallesKioskPage = () => {
  const isYPF = localStorage.getItem("bandera") === "ypf";
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const [total, setTotal] = useState(0);
  const [habilitarButton, setHabilitarButton] = useState(false);
  const [visibleBotonPagos, setVisibleBotonPagos] = useState(isYPF);
  const [irMetodoDePago, setIrMetodoDePago] = useState(false);
  const [modalWidth, setModalWidth] = useState(
    window.innerWidth < 700 ? "360px" : "900px",
  );
  const [metodoPagoSeleccionado, setMetodoPagoSeleccionado] = useState(
    isYPF ? 1 : null,
  );
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [img, setImg] = useState("");
  const [desc, setDesc] = useState("");
  const [openImg, setOpenImg] = useState(false);

  const [openDialogInicio, setOpenDialogInicio] = useState(true);

  const [isProcessing, setIsProcessing] = useState(false);

  const background = fullBienvenido;

  const handleClickImg = (imgSrc, descripcion) => {
    setImg(imgSrc);
    setDesc(descripcion);
    setOpenImg(true);
  };

  const handleCloseImg = () => {
    setImg("");
    setOpenImg(false);
  };
  const [itemToDelete, setItemToDelete] = useState(null);

  const factura = consumidorFinal => {
    const cliente = consumidorFinal ? null : { idCliente: 1 };
    const facturaInfo = generarFacturaInfo(productos, cliente);
    localStorage.setItem("facturaInfo", JSON.stringify(facturaInfo));
    if (!isYPF) {
      setIrMetodoDePago(true);
    }
  };

  // Función para manejar el pago según el método seleccionado
  const handlePagar = () => {
    factura(true);
    if (!metodoPagoSeleccionado) return;

    // Mapeo de IDs a métodos de pago
    const metodosMap = {
      1: "ypf", // App YPF
      2: "mercadopago", // Mercado Pago
      3: "modo", // Modo
      4: "credito", // Tarjeta de Crédito
      5: "debito", // Tarjeta de Débito
      6: "efectivo", // Efectivo al vendedor
    };

    const medioDePago = metodosMap[metodoPagoSeleccionado];
    const totalFormateado = Number(total).toLocaleString("es-ES", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    if (metodoPagoSeleccionado === 1 && isYPF) {
      const listadoQR = localStorage.getItem("conListadoQR");
      localStorage.setItem("totalProductos", total.toFixed(2));
      if (listadoQR == "true") {
        navigate("/listadoqrpage");
      } else if (listadoQR == "false") {
        navigate("/pagoqrpage");
      } else {
        navigate("/listadoqrpage");
      }
      return;
    }

    // Navegar a la pantalla de procesamiento de pago
    navigate(
      `/pagokioskpage?metodoPago=${medioDePago}&total=${totalFormateado}`,
    );
  };

  const {
    productos,
    clearProductos,
    updateProducto,
    addProducto,
    idProductoArray,
    setIdProductoArray,
  } = useProductStore();

  useEffect(() => {
    if (location.state?.limpiarProductos) {
      console.log(
        "[DetallesKioskPage] limpiarProductos detectado - limpiando carrito",
      );
      clearProductos();
    }
  }, [location.state]);

  const calcularTotal = () => {
    let sumaTotal = 0;
    productos.forEach(producto => {
      sumaTotal += producto.importe;
    });
    setTotal(sumaTotal);
  };

  const handleDelete = (id, descripcion) => {
    setItemToDelete({ id, descripcion });
    setOpenDeleteDialog(true);
  };

  const handleConfirmDelete = () => {
    if (itemToDelete) {
      handleDeleteRow(itemToDelete.id, productos, updateProducto);
    }
    setOpenDeleteDialog(false);
    setItemToDelete(null);
  };

  const handleCancelDelete = () => {
    setOpenDeleteDialog(false);
    setItemToDelete(null);
  };

  const inputRef = useRef(null);

  const processBarcode = async barcode => {
    setIsProcessing(true);

    if (barcode.length > 0) {
      try {
        const response = await articulosTotem.getArticulosTotem(barcode);

        const items = response.data.items || response.data;

        if (items && items.length > 0) {
          const productData = items[0];

          const existingProduct = productos.find(
            p => p.idArticulo === productData.idArticulo,
          );

          if (existingProduct) {
            handleIncrementProduct(
              existingProduct.idProductoArray,
              productos,
              updateProducto,
            );
          } else {
            let imagenBase64 = null;
            try {
              const imgResponse = await catalogo.getImagenArticulo(
                productData.idArticulo,
              );
              imagenBase64 = imgResponse?.imagenBase64 || null;
            } catch (error) {
              console.error("Error fetching image:", error);

              setIsProcessing(false);
            }

            const newProduct = {
              ...productData,
              cantidadArticulo: 1,
              importe: productData.precioPublico || productData.precioUnitario,
              idProductoArray: idProductoArray,
              imagenBase64: imagenBase64,
            };
            addProducto(newProduct);
            setIdProductoArray(idProductoArray + 1);
          }
        }
      } catch (error) {
        console.error("Error scanning barcode:", error);
        setIsProcessing(false);
      }
      setIsProcessing(false);
    }
  };

  const handleInputKeyDown = e => {
    if (e.key === "Enter") {
      // DEBUG: Ver qué llega desde input manual
      //alert(
      //  `PC - Código: "${e.target.value}" | Longitud: ${e.target.value.length} | Productos actuales: ${productos.length}`,
      //);

      processBarcode(e.target.value);
      e.target.value = "";
    }
  };

  const handleAbrirScanner = () => {
    if (
      window.MyInterface &&
      typeof window.MyInterface.scanProduct === "function"
    ) {
      window.MyInterface.scanProduct();
    } else {
      console.warn(
        "MyInterface no está disponible o scanProduct no es una función",
      );
    }
    // Asegurar que el input oculto mantenga el focus después del click
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 10);
  };

  useEffect(() => {
    const syncGUID = uuidv4();
    localStorage.setItem("syncGUID", JSON.stringify(syncGUID));
    const focusInput = () => {
      if (inputRef.current && document.activeElement !== inputRef.current) {
        inputRef.current.focus();
      }
    };

    focusInput();

    // Reducir el intervalo para hacer focus más frecuentemente
    const interval = setInterval(focusInput, 1000);

    // Agregar más eventos para asegurar el focus
    const events = ["click", "touchstart", "keydown"];
    events.forEach(event => {
      window.addEventListener(event, focusInput);
    });

    return () => {
      clearInterval(interval);
      events.forEach(event => {
        window.removeEventListener(event, focusInput);
      });
    };
  }, []);

  useEffect(() => {
    const eventListener = async event => {
      const barcode = event.detail.barcode;

      // DEBUG: Ver qué llega desde Clover
      // alert(`CLOVER - Código: "${barcode}" | Longitud: ${barcode.length}`);

      // Redirigir al input oculto para evitar race conditions
      if (inputRef.current) {
        inputRef.current.value = barcode;
        // Llamar a la función handleInputKeyDown
        const mockEvent = {
          key: "Enter",
          target: { value: barcode },
        };
        handleInputKeyDown(mockEvent);
      }
    };

    window.addEventListener("scanComplete", eventListener);

    return () => {
      window.removeEventListener("scanComplete", eventListener);
    };
  }, [productos]);

  useEffect(() => {
    // Solo habilitar el botón si estamos en métodos de pago Y hay uno seleccionado
    // O si no estamos en métodos de pago (pantalla anterior)
    if (irMetodoDePago) {
      setHabilitarButton(metodoPagoSeleccionado !== null);
      setVisibleBotonPagos(true);
    } else {
      setHabilitarButton(false);
      setVisibleBotonPagos(false);
    }
  }, [irMetodoDePago, metodoPagoSeleccionado]);

  useEffect(() => {
    calcularTotal();
    setHabilitarButton(productos.length > 0);
  }, [productos]);

  useEffect(() => {
    if (isYPF) {
      factura(true);
      setVisibleBotonPagos(true);
      setMetodoPagoSeleccionado(1);
    }
  }, []);

  // Timer de inactividad
  useEffect(() => {
    let inactivityTimer;

    const resetTimer = () => {
      clearTimeout(inactivityTimer);
      setOpenDialogInicio(false);
      inactivityTimer = setTimeout(() => {
        setOpenDialogInicio(true);
      }, 120000); // 2 minutos
    };

    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
      "click",
    ];

    events.forEach(event => {
      document.addEventListener(event, resetTimer);
    });

    return () => {
      clearTimeout(inactivityTimer);
      events.forEach(event => {
        document.removeEventListener(event, resetTimer);
      });
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 700) {
        setModalWidth("360px");
        navigate("/");
      } else {
        setModalWidth("900px");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <MenuSection />
      <input
        data-testid="barcode-input"
        ref={inputRef}
        autoFocus
        inputMode="none"
        autoComplete="off"
        style={{
          opacity: 0,
          position: "absolute",
          top: 0,
          left: 0,
          width: "1px",
          height: "1px",
          overflow: "hidden",
          border: "none",
          margin: 0,
          padding: 0,
        }}
        onKeyDown={handleInputKeyDown}
        onBlur={() => {
          // Usar un timeout más corto para recuperar el focus más rápidamente
          setTimeout(() => {
            if (
              inputRef.current &&
              document.activeElement !== inputRef.current
            ) {
              inputRef.current.focus();
            }
          }, 10);
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "40rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          left: "18rem",
          zIndex: 999,
        }}
      >
        <img
          src={scanning}
          alt="Scanning"
          style={{
            width: "150px",
            height: "130px",
            marginBottom: "1rem",
          }}
        />
        <Button
          variant="contained"
          sx={{
            boxShadow: 0,
            fontWeight: "bold",
            fontSize: 13,
            mb: 2,
            backgroundColor: theme.bandera.colorSecundario,
            ":hover": {
              backgroundColor: theme.bandera.colorSecundario,
            },
            zIndex: 9999,
            position: "relative",
          }}
          onClick={handleAbrirScanner}
          onMouseDown={e => e.preventDefault()}
        >
          LEER CODIGO DE BARRAS
        </Button>

        <Typography
          sx={{
            fontSize: "1.5rem",
            mb: 3,
            width: "280px",
            textAlign: "center",
            color: isProcessing ? theme.palette.primary.main : "inherit",
          }}
        >
          {isProcessing ? " PROCESANDO ..." : "ESCANEA TU PRODUCTO"}
        </Typography>

        {isProcessing && (
          <Box sx={{ width: "70%", position: "absolute", top: "16.5rem" }}>
            <LinearProgress />
          </Box>
        )}
      </Box>
      <Grid
        container
        direction="column"
        sx={{ height: "90vh", mt: 15, zIndex: 1 }}
      >
        {irMetodoDePago ? (
          <MetodosPagosKiosk
            metodoPagoSeleccionado={metodoPagoSeleccionado}
            setMetodoPagoSeleccionado={setMetodoPagoSeleccionado}
          />
        ) : (
          <Detalles
            productos={productos}
            isYPF={isYPF}
            factura={factura}
            handleDelete={handleDelete}
            handleIncrease={id =>
              handleIncrementProduct(id, productos, updateProducto)
            }
            handleDecrease={id =>
              handleDecrementProduct(id, productos, updateProducto)
            }
            handleClickImg={handleClickImg}
          />
        )}

        {/* <IconButton
          onClick={() =>
            irMetodoDePago
              ? setIrMetodoDePago(false)
              : navigate("/tiendakioskpage", {
                  state: { vieneDeDetalles: true },
                })
          }
          sx={{ justifyContent: "start", ml: 2, mb: 2 }}
          // sx={{ mr: 10, position: "absolute", bottom: "32.5rem", left: "2rem" }}
        >
          <ArrowCircleLeftIcon
            sx={{ fontSize: 60, color: theme.bandera.colorSecundario }}
          />
        </IconButton> */}
        <Grid item sx={{ flex: 0.5, mb: 4 }}>
          <Box
            sx={{
              p: 3,
              backgroundColor: "#fff",
              borderRadius: 1,
              height: "110px",
            }}
          >
            <TotalBar
              total={total}
              habilitarButton={habilitarButton}
              onPagar={handlePagar}
              visibleBotonPagos={visibleBotonPagos}
            />
          </Box>
        </Grid>
        {/* <Promociones /> */}
      </Grid>

      {/* Dialog de confirmación para eliminar */}
      <Dialog open={openDeleteDialog} onClose={handleCancelDelete}>
        <DialogContent sx={{ mt: 4 }}>
          <Typography variant="h4">
            ¿Estás seguro de que deseas eliminar "{itemToDelete?.descripcion}"?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCancelDelete}
            sx={{ fontSize: 20, color: theme.bandera.colorSecundario, mr: 2 }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmDelete}
            sx={{ fontSize: 20, bgcolor: theme.bandera.colorSecundario, m: 2 }}
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      <DialogImg
        imgSrc={img}
        desc={desc}
        open={openImg}
        onClose={() => handleCloseImg()}
      />

      <Dialog
        open={openDialogInicio}
        onClick={() => setOpenDialogInicio(false)}
        fullScreen
        TransitionComponent={Transition}
        disableScrollLock
        keepMounted={false}
      >
        <img
          src={background}
          alt="Bienvenido"
          style={{ width: "100%", height: "100vh" }}
        />
      </Dialog>
    </>
  );
};
